<span
  class="rating-cell"
  [ngClass]="{
    rated: cellContent && cellContent !== 'Var',
    enhanced: !isUnderlyingViewOn && allEnhanced && cellContent !== '-',
    'enhanced-underlying': isUnderlyingViewOn && allEnhanced
  }"
  [style.lineHeight]="height + 'px'"
  [sprTooltip]="tooltipContent"
  [sprTooltipOptions]="tooltipOptions"
  [attr.data-automation-e2e-selector]="automationSelector('rating')"
  >{{ cellContent || '-' }}</span
>
